// Globally register all filters for convenience, by their file name.
import Vue from 'vue'
import { eachInContext } from '@evolve/helpers/RequireHelper'

eachInContext(require.context('./filters'), Vue.filter.bind(Vue))
